jQuery(document).ready(function($) 
{
/*     'use strict'; */

    const Hamburger = $(".hamburger");
    const Topbar = $(".topbar path");
    // var TopbarLogo = $(".topbarlogo");

    alignTitleSlider();
    addEffectBlock();
    handleSubMenu();

    // Topbar.addClass("topbarlogo");
    Hamburger.click(function()
    {
        $(".offcanvas-container").toggle();
        $(".topBlue").toggle();
        $(".bottomBlue").toggle();
        // Topbar.toggleClass("blue");
        Hamburger.toggleClass("active");
        if($(window).width() > 1024) {
            Hamburger.toggleClass("blue-hamburger");
        }

        if(Hamburger.hasClass("active")) {
            clearTimeout($.data(window, 'scrollTimer'));
            $('body').css('overflow-y', 'hidden');
            if($(window).width() < 1024) {
                $('.top-container').css('height', '100vh');
            }
        } else {        
            $('body').css('overflow-y', 'auto');
            $('.top-container').css('height', 'auto');
            if ($(window).scrollTop() > 0) {
                $.data(window, 'scrollTimer', setTimeout(function() {
                    $('.site-navbar-content').removeClass('sticky').hide();
                }, 1000)); 
            }
        }

        if($(".wrap.submenu").hasClass("active"))
            $(".wrap.submenu").toggleClass("active");
    });

    $(".offcanvas-container").click(function(event) 
    {
        if(event.target.nodeName == "LI")
        {   
            if(event.target.childElementCount > 1) {
                /* only if there is a sub menu */
                var html = event.target.outerHTML;
                $(".wrap.submenu").css("width", "0");
                $(".wrap.submenu").toggleClass("active").animate({width:"100%"});
                $(".inside.submenu").html(html);
            } 
        }
    });

    /* handling :after pseudo element - arrow - if the menu item hasn't sub menu */
    function handleSubMenu(e) {
        const menuItem = $('#menu-offcanvas > li');
        menuItem.each(function(i, item) {
            if(!$(item).children()[1]) {
                $(item).addClass('remove-after');
            }
        });
    }

    $(".back.button").click(function()
    {
        Hamburger.trigger("click");
        Hamburger.trigger("click");
    });

    /**
     * Filter Mediagrid
     */
    $(".mediagrid-filter, #post-year a").click(function(event) 
    {
        event.preventDefault();
        var year = $(this).data('year');

        $.ajax({
            type: 'POST',
            url: filter_ajax.url,
            dataType: 'html',
            data: {
              action: 'filter_mediagrid',
              security : filter_ajax.security,
              termID: $(this).data('id'),
              termYear: $(this).data('year'),
              numPost: $(this).data('increment'),
            },
            success: function(dataPost) {

                if(year != '') {
                    $('#post-year')
                    .fadeOut( "slow", function() {
                        $(this).find('span#date').empty().html(year);
                        $(this).fadeIn();
                    });
                }
                else {
                    $('#post-year').fadeOut(); 
                }
                
                $('#mediagrid-component-output')
                .fadeOut( "slow", function() {
                    $(this).empty().html(dataPost).fadeIn();
                });
                $('#media-loadmore').attr('data-year', year);
            }
          });
    });

    $("#media-loadmore").click(function(event) 
    {
        event.preventDefault();

        $('#media-loadmore').fadeOut("fast");

        var NumPost = $("#mediagrid-component-output > div").length;
        var year = $(this).data('year');
        var increment = NumPost + $(this).data('increment');

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
              action: 'filter_mediagrid',
              termID: $(this).data('id'),
              termYear: $(this).data('year'),
              lang: $(this).data('lang'),
              numPost: increment,
            },
            success: function(dataPost) {

                if(year != '') {
                    $('#post-year')
                    .fadeOut( "slow", function() {
                        $(this).find('span#date').empty().html(year);
                        $(this).fadeIn();
                    });
                }
                else {
                    $('#post-year').fadeOut(); 
                }

                $('#mediagrid-component-output')
                .fadeOut( "slow", function() {
                    $(this).empty().html(dataPost).fadeIn("fast", function() {
                        
                        var visibleNumPost = $("#mediagrid-component-output > div").length;
                        
                        console.log(visibleNumPost);
                        console.log($('#media-loadmore').data('totalpost'));

                        if(visibleNumPost < $('#media-loadmore').data('totalpost')) {
                            $('#media-loadmore').fadeIn("fast");
                        }

                    });
                });

            }
          });
    });

    $(".card-zip-download > a").click(function(event) 
    {
        let files = [];
        let name = $(this).data('name');
        let IDcontent = $(this).data('target');
        let Getcontent = $('#' + IDcontent + ' a');

        Getcontent.each(function( index ) {
            let url = $( this ).attr('href')
            url = url.replace(/^.*\/\/[^\/]+\//, '')
            if(url != 'javascript:void(0)') {
                files.push(url);
            }
        });

        console.log(files);

        $.ajax({
            type: 'POST',
            url: filter_ajax.url,
            dataType: 'html',
            data: {
              action: 'create_zip_review',
              security : filter_ajax.security,
              files: files,
              name: name
            },
            success: function(dataPost) {
                console.log(dataPost);
                let dataPostObj = JSON.parse(dataPost);
                if(dataPostObj.status == 'ERROR') {
                    alert(dataPostObj.message);
                } else {
                    window.location = dataPostObj.url;
                }
            }
        });
    });

    function alignTitleSlider(event) {
        if ($('.showcase-slider__block_object__group__cta a').length) {
            /*
            var Cta = $('.showcase-slider__block_object__group__cta a');
            var _x = Cta.position().left;
            */
            var Text = $('.showcase-slider__block_object__group__items__text');

            const offset = 0;

            var _x = $('.topbar .wrap.logo').position().left;
            var _x_w = $('.topbar .wrap.logo').width();
            _x += _x_w/3;
  
            if($(window).width() <= 768) {
                _x = 0;
            }

            switch(event) {
                case 'resize':
                    Text.css('left', _x + offset);
                break;
                default:
                    Text.fadeOut('fast').animate({
                        'left': _x + offset
                    }, 1000, function() {
                        $(this).fadeIn('slow');
                    });
            }
        }
    }

    function addEffectBlock() {
        $('.site-image-zoom figure').attr('data-aos','zoom-out').attr('data-aos-duration','1000').attr('data-aos-easing',"linear");
    }

    function numberCounter() {
        $('.count').each(function () {
            if($(this).visible(true, false, 'vertical')) {
                var number = $(this).attr('data-number');
                var decimal = $(this).attr('data-decimal');
                var min_width = $(this).width();
                
                $(this).css('opacity', 0)
                    .css('display', 'inline-block')
                    .css('text-align', 'right')
                    .css('min-width', min_width + 'px');

                $(this).prop('Counter',0).animate({
                    Counter: number,
                    opacity: 1
                }, {
                    duration: 2000,
                    easing: 'swing',
                    start: function () {
                        $(this).toggleClass('count');
                    },
                    step: function (now) {
                        $(this).text(new Intl.NumberFormat($('html').attr('lang'), {maximumFractionDigits: decimal}).format(this.Counter));
                    },
                    complete: function () {
                        $(this).text(new Intl.NumberFormat($('html').attr('lang'), {maximumFractionDigits: decimal}).format(this.Counter));
                    },
                });
            }
        });
    }

    $('#review').on('hidden.bs.collapse', function () {
     
    });

    $('#review').on('show.bs.collapse', function () {

    });
    numberCounter();

    $( window ).resize(function() {
        alignTitleSlider('resize');
    });

    $(window).scroll(function() {
        /* sticky menu */
        if($(window).width() < 768) {
            $('.site-navbar-content').addClass('sticky').show();
            clearTimeout($.data(this, 'scrollTimer'));
            /* console.log($(window).scrollTop()); */
            if($(window).scrollTop() <= 180) {
                clearTimeout($.data(this, 'scrollTimer'));
                $('.site-navbar-content').removeClass('sticky').show('fast'); 
            }
            else if($(".offcanvas-container").is(':hidden') && ($(window).scrollTop() > 180 ) )  {
                $.data(this, 'scrollTimer', setTimeout(function() {
                    $('.site-navbar-content').removeClass('sticky').hide();
                }, 1500)); 
            }
        } else {
            clearTimeout($.data(this, 'scrollTimer'));
            $('.site-navbar-content').removeClass('sticky').show('fast');
        }

        /* counter sui numeri */
        numberCounter();

    });
    

    AOS.init();
});